import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { resizeImage } from '../../utilities/image-utilities';

@Component({
    selector: 'pace-core-camera-modal',
    templateUrl: './camera-modal.component.html',
    styleUrls: ['./camera-modal.component.scss'],
    standalone: false,
})
export class CameraModalComponent implements OnInit, OnDestroy {
    @ViewChild('videoEl') private videoEl: ElementRef<HTMLVideoElement>;
    @ViewChild('canvasEl') private canvasEl: ElementRef<HTMLCanvasElement>;

    @Output() public photoCaptured = new EventEmitter<File>();

    public error = false;

    private active = false;
    private cameraStream: MediaStream | undefined;

    public constructor(
        private readonly cdr: ChangeDetectorRef,
        private readonly modalRef: BsModalRef,
    ) {}
    public ngOnInit(): void {
        this.open();
    }

    private open(): void {
        this.error = false;
        this.active = true;
        navigator.mediaDevices
            .getUserMedia({ video: { facingMode: 'environment' }, audio: false })
            .then((stream) => {
                if (!this.active) {
                    this.stopStream(stream);
                    return;
                }
                this.cameraStream = stream;
                if (this.video) {
                    this.video.srcObject = stream;
                }
            })
            .catch(() => {
                this.error = true;
            });
    }

    public async capture(): Promise<void> {
        const video = this.video;
        const canvas = this.canvasEl?.nativeElement;
        if (!video || video.videoWidth === 0 || video.videoHeight === 0) {
            return;
        }
        const file = await resizeImage(video, canvas);
        if (!file) {
            return;
        }
        this.photoCaptured.emit(file);
        this.cdr.markForCheck();
        this.close();
    }

    public close(): void {
        this.active = false;
        this.stopStream(this.cameraStream);
        this.modalRef?.hide();
    }

    public ngOnDestroy(): void {
        this.photoCaptured.complete();
        this.close();
    }

    private stopStream(stream: MediaStream | undefined): void {
        stream?.getTracks().forEach((track) => track.stop());
        this.cameraStream = undefined;
    }

    private get video(): HTMLVideoElement | undefined {
        return this.videoEl?.nativeElement;
    }
}
